<template>
  <div class="live-pulse-indicator pulse-generator-content">
    <v-tooltip v-if="tooltip" top>
      <template v-slot:activator="{ on }">
        <div class="live-pulse-indicator__target" v-on="on">
          <div :class="pulseClass" :style="sizeStyle" />
          <v-icon
            v-show="!showErrorIcon"
            class="pulse-generator-child"
            :style="sizeStyle"
          >
            {{ icon }}
          </v-icon>
          <v-icon
            v-show="showErrorIcon"
            small
            class="pulse-generator-child"
            color="error"
            :style="sizeStyle"
          >
            {{ errorIcon }}
          </v-icon>
        </div>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <div v-else class="live-pulse-indicator__target">
      <div :class="pulseClass" :style="sizeStyle" />
      <v-icon
        v-show="!showErrorIcon"
        class="pulse-generator-child"
        :style="sizeStyle"
      >
        {{ icon }}
      </v-icon>
      <v-icon
        v-show="showErrorIcon"
        small
        class="pulse-generator-child"
        color="error"
        :style="sizeStyle"
      >
        {{ errorIcon }}
      </v-icon>
    </div>
  </div>
</template>

<style scoped>
.live-pulse-indicator__target {
  position: relative;
  display: inline-block;
}

.live-pulse-indicator__target .pulse-generator-child {
  top: 10px;
  left: 10px;
}
</style>

<script>
import src from './src'
export default src
</script>
